const actions = {
  resetResultState: 'RESET_RESULT_STATE',
  createResult: 'CREATE_RESULT',
  updateResult: 'UPDATE_RESULT',
  listResult: 'LIST_RESULT',
  getResult: 'GET_RESULT',
  getPlayerMinutesPlayer: 'GET_MINUTES_PLAYED',
  updateMinutesPlayed: 'UPDATE_MINUTES_PLAYED',
  getPlayerAngleData: 'GET_PLAYER_ANGLE_DATA',
  updateAngleData: 'UPDATE_ANGLE_DATA',
  getPlayerROMData: 'GET_PLAYER_ROM_DATA',
  updatePlayerROMData: 'UPDATE_PLAYER_ROM_DATA',
};

export default actions;
